import {
   GET_PURCHASE_INVOICES,
   GET_PURCHASE_INVOICE,
   ADD_PURCHASE_INVOICE,
   GET_PURCHASE_INVOICES_TRANSACTIONS,
   UPDATE_PURCHASE_INVOICE,
   DELETE_PURCHASE_INVOICE,
   LAST_BILL_PURCHASE_INVOICE,
   GET_LAST_PURCHASE_DAYBOOK,
   DELETE_PURCHASE_LINE_ITEM,
   ADD_PURCHASE_LINE_ITEM,
   UPDATE_PURCHASE_LINE_ITEM,
   GET_PURCHASE_LINE_ITEM,
   GET_PURCHASE_LINE_ITEMS,
   SET_LOADING,
   GET_ONE_PURCHASE_INVOICE,
   EMPTY_ONE_PURCHASE_INVOICE,
   GET_PURCHASE_INVOICE_WITH_PREV_AND_NEXT,
   GET_PURCHASE_INVOICE_PREV_AND_NEXT,
   GET_PENDING_VOUCHER_PURCHASE_ADJUSTMENT,
   UPDATE_SYNC_PURCHASE_INVOICE,
   GRAY_PURCHASE_PENDING_ISSUE,
   GET_PURCHASE_INVOICES_FOR_DAYBOOK,
} from '../types';

const initialState = {
   list: [],
   single: null,
   totalCount: 0,
   lastBill: null,
   lastPurchaseDaybook: null,
   isLoading: false,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
   purchaseData: null,
   prevAndNext: null,
   pendingPurchaseAdjustment: [],
   grayPurchasePendingIssue: [],
};

const reducer = (state = initialState, action) => {
   const { type, payload, totalCount } = action;

   switch (type) {
      case SET_LOADING:
         return {
            ...state,
            isLoading: payload,
         };

      case EMPTY_ONE_PURCHASE_INVOICE:
         return {
            ...state,
            single: payload,
         };
      case GET_PURCHASE_INVOICES:
         return {
            ...state,
            list: payload?.data,
            totalCount: totalCount,
            isLoading: false,
            pagination: action.payload.pagination,
         };

      case GET_PURCHASE_INVOICES_FOR_DAYBOOK:
         return {
            ...state,
            listForDaybook: payload?.data,
            totalCountForDaybook: totalCount,
            isLoadingForDaybook: false,
            paginationForDaybook: action.payload.pagination,
         };

      case GET_PURCHASE_INVOICE:
         return {
            ...state,
            single: payload || initialState.single,
            isLoading: false,
         };

      case GET_PURCHASE_INVOICES_TRANSACTIONS:
         return {
            ...state,
            data: payload.data || initialState.single,
            isLoading: false,
         };

      case UPDATE_PURCHASE_INVOICE:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case UPDATE_SYNC_PURCHASE_INVOICE:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
            isLoading: false,
         };

      case ADD_PURCHASE_INVOICE:
         return {
            ...state,
            list: [payload, ...state.list],
            totalCount: state.totalCount + 1,
            isLoading: false,
         };

      case DELETE_PURCHASE_INVOICE:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
            totalCount: state.totalCount - 1,
            isLoading: false,
         };

      case LAST_BILL_PURCHASE_INVOICE:
         return {
            ...state,
            lastBill: payload,
         };

      case GET_LAST_PURCHASE_DAYBOOK:
         return {
            ...state,
            lastPurchaseDaybook: payload,
         };

      case GET_PURCHASE_LINE_ITEMS:
         return { ...state, list: payload };

      case GET_PURCHASE_LINE_ITEM:
         return { ...state, single: payload || initialState.single };

      case UPDATE_PURCHASE_LINE_ITEM:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case ADD_PURCHASE_LINE_ITEM:
         return {
            ...state,
            list: [payload, ...state.list],
         };

      case DELETE_PURCHASE_LINE_ITEM:
         return {
            ...state,
            list: state.list.filter((item) => item.id !== payload.id),
         };

      case GET_ONE_PURCHASE_INVOICE:
         return { ...state, single: payload || initialState.single };

      case GET_PURCHASE_INVOICE_WITH_PREV_AND_NEXT:
         return {
            ...state,
            purchaseData: { data: payload.data, pagination: payload.pagination, totalCount: payload.totalCount },
         };

      case GET_PURCHASE_INVOICE_PREV_AND_NEXT:
         return {
            ...state,
            prevAndNext: payload,
         };

      case GET_PENDING_VOUCHER_PURCHASE_ADJUSTMENT:
         return {
            ...state,
            pendingPurchaseAdjustment: payload,
            isLoading: false,
         };

      case GRAY_PURCHASE_PENDING_ISSUE:
         return { ...state, grayPurchasePendingIssue: payload, isLoading: false };

      default:
         return state;
   }
};

export default reducer;
